document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('.wage');
  const incomeInput = document.querySelector('#income');
  const dependentsSelect = document.querySelector('#dependents_select');
  const wifeSelect = document.querySelector('#wife_select');
  const priorityClaimsCheckbox = document.querySelector(
    '#priority_claims_checkbox'
  );

  const baseAmount = document.querySelector('#base_amount');
  const deductedAmountWithoutLimit = document.querySelector(
    '#deducted_amount_without_limit'
  );
  const totalForfeitableAmount = document.querySelector(
    '#total_forfeitable_amount'
  );
  const totalDeduction = document.querySelector('#total_deduction');

  if (form) {
    incomeInput.addEventListener('keyup', function (event) {
      calc();
    });

    dependentsSelect.addEventListener('change', function (event) {
      calc();
    });

    wifeSelect.addEventListener('change', function (event) {
      calc();
    });

    priorityClaimsCheckbox.addEventListener('change', function (event) {
      calc();
    });
  }

  function calc() {
    const cistyPrijem = Math.max(
      parseInt(document.getElementById('income').value),
      1
    );
    const partner =
      !!parseInt(document.getElementById('wife_select').value) > 0 ? 1 : 0;
    const vyzivovanychOsob = Math.max(
      parseInt(document.getElementById('dependents_select').value),
      0
    );

    const prednostniPohledavky = document.getElementById(
      'priority_claims_checkbox'
    ).checked
      ? 1
      : 0;

    let resultArray = spocitej2Castky(
      cistyPrijem,
      partner,
      vyzivovanychOsob,
      prednostniPohledavky
    );

    baseAmount.innerHTML = formatNumber(resultArray.zaklad) + ' Kč';

    deductedAmountWithoutLimit.innerHTML =
      formatNumber(resultArray.srazka_bezomez) + ' Kč';

    totalDeduction.innerHTML = formatNumber(resultArray.srazka) + ' Kč';

    totalForfeitableAmount.innerHTML =
      formatNumber(resultArray.nezabavit) + ' Kč';
  }

  /**
   *
   * @param prijem2 int
   * @param manzel2 0|1
   * @param osoby2 int
   * @param prednostni2 0|1
   */
  function spocitej2Castky(
    prijem2 = 20000,
    manzel2 = 0,
    osoby2 = 0,
    prednostni2 = 0
  ) {
    const zaklad = Math.ceil(
      (2 / 3) * (4860 + 14680) +
        (1 / 4) * osoby2 * ((2 / 3) * (4860 + 14680)) +
        (1 / 4) * manzel2 * ((2 / 3) * (4860 + 14680))
    );
    const srazka_bezomez =
      prijem2 - zaklad - (1.5 * (4860 + 14680)) > 0
        ? prijem2 - zaklad - 1.5 * (4860 + 14680)
        : 0;

    const tmp = Math.floor(prijem2 - zaklad - srazka_bezomez);
    const srazka =
      prednostni2 > 0
        ? (2 * (tmp % 3 === 0 ? tmp : tmp % 3 === 1 ? tmp - 1 : tmp - 2)) / 3 +
          srazka_bezomez
        : (tmp % 3 === 0 ? tmp : tmp % 3 === 1 ? tmp - 1 : tmp - 2) / 3 +
          srazka_bezomez;

    let nezabavit = 0;
    if (srazka > 0) {
      nezabavit = prijem2 - srazka;
    } else {
      nezabavit = prijem2;
    }

    return {
      zaklad: zaklad < 0 ? 0 : zaklad,
      srazka: srazka < 0 ? 0 : srazka,
      srazka_bezomez: srazka_bezomez < 0 ? 0 : srazka_bezomez,
      nezabavit: nezabavit < 0 ? 0 : nezabavit,
    };
  }

  /**
   * @param number
   * @return {string}
   */
  function formatNumber(number) {
    return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1&nbsp;');
  }
});
